import { render, staticRenderFns } from "./MapEditor.vue?vue&type=template&id=bcf1af1e"
import script from "./MapEditor.vue?vue&type=script&lang=ts"
export * from "./MapEditor.vue?vue&type=script&lang=ts"
import style0 from "./MapEditor.vue?vue&type=style&index=0&id=bcf1af1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports